import styled from "styled-components";

export const ContactSection = styled.section`
  margin-left: 3rem;
  width: 80vw;
  display: flex;
  margin-left: 10vw;
  margin-top: 100px;
  padding-top: 20px;
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
    width: calc(100% - 13vw - 20px);
    margin-top: 20px;
    margin-bottom: 50px;
    font-size: 14px;
    margin-left: calc(13vw + 20px);
  }
  .left {
    width: 50%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
    h2 {
      margin-bottom: 20px;
      @media screen and (max-width: 768px) {
        display: none;
        
      }
    }

    p {
      margin-bottom: 5vh;
    }
  }

  .right {
    width: 50%;

    @media screen and (max-width: 768px) {
      width: 100%;
    }
    h3 {
      margin-bottom: 25px;
    }
    form {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;
      width: 60%;
      @media screen and (max-width: 768px) {
        width: 90%;
      }

      input,
      textarea {
        padding: 0.5rem 0.5rem;
        width: 100%;
      }
      .btn-container {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        button {
          width: 50%;
          padding: 0.6rem 0;
          background-color: rgba(100, 100, 250, 0.5);
          border: none;
          border-radius: 5px;
          color: white;
          font-weight: 700;
          font-size: 1.1rem;
        }
      }
    }

    .error-msg {
      font-size: 13px;
      margin-top: 20px;
      color: red;
      width: 60%;
      @media screen and (max-width: 768px) {
        width: 90%;
      }
    }
  }
`;
